<script lang="ts">import { resolvePromotionDescriptionDisplay } from "../data";
import { locale, t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import PromoCardFooter from "./promo-item/promo-item-footer.svelte";
export let promo;
export let compact = false;
$: imageUrl = compact || $isMobile ? promo.banner : promo.bannerBig ?? promo.banner;
$: promoDescriptionDisplay = resolvePromotionDescriptionDisplay(promo, $locale, $t);
</script>

<div class="promo-item-momentum" class:promo-item-momentum-compact={compact}>
	<div class="promo-item-momentum-aspect" class:promo-item-momentum-aspect-compact={compact}>
		<div class="variant-banner-container-detail-momentum">
			<img src={imageUrl} alt="" class="variant-banner-container-detail-momentum-image" />
			<div class="variant-banner-container-detail-momentum-text">
				<h2 class="momentum-title">{$t(promo.title as VerbiageKey)}</h2>
				<p class="momentum-description">{promoDescriptionDisplay}</p>
			</div>
		</div>
	</div>
	{#if compact}
		<PromoCardFooter {promo} active={true} isDetail={false} isBigScreen={false} />
	{/if}
</div>

<style>
	.promo-item-momentum {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.promo-item-momentum-aspect {
		position: relative;
		width: 100%;
	}

	.promo-item-momentum-aspect-compact {
		flex: 1;
		display: flex;
		min-height: 0;
	}

	.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) {
		padding-bottom: calc(166 / 361 * 100%);
		overflow: hidden;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) {
			padding-bottom: calc(200 / 1168 * 100%);
		}
	}

	.variant-banner-container-detail-momentum {
		background: rgba(255, 255, 255, 0.05);
		border-radius: 12px;
		overflow: hidden;
	}

	.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
		.variant-banner-container-detail-momentum {
		position: absolute;
		top: 0px;
		left: 0px;
		height: 100%;
		width: 100%;
}

	.promo-item-momentum-aspect-compact .variant-banner-container-detail-momentum {
		position: relative;
		width: 100%;
		flex: 1;
		height: 100%;
		padding: 20px 45% 20px 20px;
		border-radius: 12px 12px 0 0;
	}

	.variant-banner-container-detail-momentum-image {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
		z-index: 0;
	}

	.variant-banner-container-detail-momentum-text {
		position: relative;
		z-index: 10;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
	}

	.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
		.variant-banner-container-detail-momentum-text {
		position: absolute;
		left: 20px;
		top: 20px;
		width: 174px;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-text {
			left: 42px;
			top: 55px;
			width: 550px;
		}
	}

	.promo-item-momentum-aspect-compact .variant-banner-container-detail-momentum-text {
		width: 100%;
		max-width: 174px;
	}

	.momentum-title {
		margin: 0;
		width: 100%;
		font-family: var(--font-main);
		font-weight: 800;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: -0.5px;
		text-transform: uppercase;
		color: #ffffff;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) .momentum-title {
			font-size: 40px;
		}
	}

	.momentum-description {
		margin: 0;
		font-family: var(--font-main);
		font-weight: 700;
		font-size: 14px;
		line-height: 120%;
		letter-spacing: -0.5px;
		color: #ffffff;
	}

	.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) .momentum-description {
		width: 142px;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) .momentum-description {
			width: 550px;
			font-size: 16px;
		}
	}

	.promo-item-momentum-aspect-compact .momentum-description {
		width: 100%;
	}

	:global(.variant-aspect-ratio-box-mobile-momentum),
	:global(.variant-aspect-ratio-box-detail-momentum),
	:global(.variant-aspect-ratio-box-detail-mobile-momentum) {
		position: relative;
		width: 100%;
	}

	:global(.variant-aspect-ratio-box-mobile-momentum) > a {
		display: block;
		width: 100%;
		overflow: hidden;
}
</style>
